module.exports = __webpack_public_path__ + "static/media/secondWitness.8a4a1d25.webp";